import App from './App.vue'
import router from './router'
import { antComponents } from './antd'
import { CommonComponents } from './use-common-components'
import 'virtual:svg-icons-register'
import store, { storeKey } from './store'
import { createInstance } from '/@/root'
import { useDirectives } from './directives'

// connectCallback/wsConnectCallback/liveStatusCallback Stubs werden im
// inline-script in index.html (head) gesetzt — vor jedem module-script —
// damit Pilot-2-Native schon ab dem allerersten HTML-Parse-Tick einen
// Handler findet. Hier nur sicherstellen dass die Buffer-Arrays existieren
// (Defense in depth, falls der head-stub aus irgendeinem Grund nicht
// gelaufen ist).
;(window as any).__pendingConnectArgs = (window as any).__pendingConnectArgs || []
;(window as any).__pendingWsConnectArgs = (window as any).__pendingWsConnectArgs || []
;(window as any).__pendingLiveStatusArgs = (window as any).__pendingLiveStatusArgs || []

import '/@/styles/index.scss'
const app = createInstance(App)

app.use(store, storeKey)
app.use(router)
app.use(CommonComponents)
app.use(antComponents)
app.use(useDirectives)
app.mount('#demo-app')
